import { defineComponent } from 'vue';
export default defineComponent({
    name: 'landing-section',
    props: {
        noPadding: Boolean,
        noSubPadding: Boolean,
        fullWidthOnMobile: Boolean,
        customCol: Boolean,
        classes: {
            type: Object,
            default: () => { }
        },
        innerStyle: {
            type: Object,
            default: () => { }
        },
        innerClass: {
            type: Object,
            default: () => { }
        }
    }
});
